/** @jsxImportSource @emotion/react */
import * as React from 'react';
import * as styles from './ProgressBar.styles';

type StepItem<TKey extends string> = { key: TKey; label: string };

export function ProgressBar<TKey extends string>({
  steps,
  activeStepKey,
  isComplete = false,
}: {
  steps: readonly StepItem<TKey>[];
  activeStepKey: TKey;
  isComplete?: boolean;
}): JSX.Element {
  const activeIndex = React.useMemo(() => {
    const idx = steps.findIndex((s) => s.key === activeStepKey);
    return idx >= 0 ? idx : 0;
  }, [steps, activeStepKey]);

  const progress = React.useMemo(() => {
    if (isComplete) {
      return 100;
    }

    if (!steps.length) {
      return 0;
    }

    return Math.min(100, ((activeIndex + 1) / steps.length) * 100);
  }, [isComplete, steps.length, activeIndex]);

  return (
    <div css={styles.progressTrack}>
      <div css={styles.progressFill(progress)} />
    </div>
  );
}
